import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-player2" }
const _hoisted_2 = {
  class: "video-player2__video",
  controls: "",
  autoplay: ""
}
const _hoisted_3 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TressVideoPlayer2',
  props: {
  videoThumbnailUrl: {
    type: String,
    required: false,
  },
  vimeoId: {
    type: String,
    required: true,
  },
},
  emits: {
  close: () => true,
},
  setup(__props, { emit: emits }) {





const onClose = () => {
  emits("close");
};

return (_ctx: any,_cache: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", _hoisted_2, [
      _createElementVNode("source", {
        src: __props.vimeoId,
        type: "video/mp4"
      }, null, 8, _hoisted_3),
      _createTextVNode(" Your browser does not support the video tag. ")
    ]),
    _createElementVNode("span", {
      onClick: onClose,
      class: "vimeo-iframe__close"
    }, [
      _createVNode(_component_icon_close)
    ])
  ]))
}
}

})